/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const query = graphql`
query AppOemTemplateFetchQuery($accountId: UUID, $appId: UUID) {
    allAppTs(condition:{accountId: $accountId, appId: $appId} orderBy:APP_NAME_ASC) {
        totalCount
        nodes {
           appId
           appTsByOemAppId {
            totalCount
          }
        }
    }
}
`;

function fetch(accountId, appId) {
const variables = {
    accountId: accountId,
    appId: appId
}

return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
);
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };
